import { Project } from "./types";
import portfolioShowcase from "../assets/portfolio-showcase-mobile.webp";
import reactIcon from "../assets/react-icon.svg";
import typescriptIcon from "../assets/typescript-icon.svg";
import sassIcon from "../assets/sass-icon.svg";

export const portfolioProject: Project = {
  title: "Portfolio",
  description:
    "I built this portfolio to showcase my skills and projects. It is built with React and TypeScript. The design was made to stand out and be bold. I learned how to make a more simple website with less clutter.",
  date: "07/2024 - 08/2024",
  image: portfolioShowcase,
  imageAlt: "Portfolio project showcase",
  technologies: [reactIcon, typescriptIcon, sassIcon],
};
